"use client";

import { Trans } from "@lingui/react/macro";

/**
 * Header component for the Account Creation step.
 * Displays the main value proposition and subheadline.
 */
export function AccountCreationHeader() {
  return (
    <div className="flex flex-col items-center">
      <h2 className="mb-2 text-center font-semibold text-2xl text-gray-900 tracking-tight sm:text-3xl">
        <Trans>Your Clients Will Think You Hired a Pro Renderer</Trans>
      </h2>
      <p className="mb-6 text-center text-base text-gray-500">
        <Trans>60-second photorealistic renders. No $500 invoices. No 5-day waits.</Trans>
      </p>
    </div>
  );
}
